import React, { useContext } from "react";
import { StateContext } from "../../../context/stateContext";
import { translations } from "../../../translate";
import BamTou from "../../tou/bamTou/BamTou";
import LegalAndPrivacyContainer from "../legalAndPrivacyContainer/LegalAndPrivacyContainer";
const TOU = () => {
  const language = useContext(StateContext).languageCode;
  return (
    <LegalAndPrivacyContainer title={translations.webAndMobileLegal[language]}>
      <BamTou />
    </LegalAndPrivacyContainer>
  );
};

export default TOU;
